import router from '@/router'
import CartAPI from '@/api/cart'
import {
  isLogin,
  loginCheckWrap,
  rewardCheckWrap,
  beforeSendLog,
  checkCountLimit
} from '@/utils'

/**m
 * 장바구니에 있는 제품 목록을 요청한다.
 * @param {*} obj
 */
const getProductListOfCart = ({ state, commit, dispatch }) => {
  CartAPI.getProductListOfCart(responseData => {
    if (responseData.data.cartList) {
      const cartList = responseData.data.cartList.map(el => {
        if (
          el.maxQuantityUser > 0 &&
          el.remainQuantityUser < 1 &&
          el.productStatus === 2
        )
          el.productStatus = -1

        if (checkCountLimit(el.purchaseCount, el, true) === false) {
          el.countLimit = true
          el.checked = false
        } else el.checked = el.productStatus === 2

        return el
      })

      commit('SET_PRODUCT_LIST_OF_CART', {
        cartList,
        purchaseCheckList: responseData.data.purchaseCheckList
      })
    }
  })
}
/**
 * 상품을 장바구니에 추가하도록 요청한다.
 * @param {*} param0
 * @param {Object} product -추가할 상품 상품
 */
const addProductOfCart = ({ state, commit, dispatch }, product) => {
  const { productId, purchaseCount, productStatus } = product
  if (productStatus === 2) {
    const cartItem = state.items.find(item => item.productId === productId)
    let newPurchaseCount
    if (cartItem) {
      newPurchaseCount = cartItem.purchaseCount + (purchaseCount || 1)
      if (newPurchaseCount < 1 || newPurchaseCount > 10) {
        dispatch('modal/openModalOrderLimitByOne', 10, {
          root: true
        })
        return false
      }
    }

    loginCheckWrap(() => {
      rewardCheckWrap(product.og, () => {
        CartAPI.addProductOfCart(product, () => {
          if (!cartItem) {
            commit('ADD_PRODUCT_TO_CART', { ...product, checked: true })
          } else {
            dispatch('updateProductStatus', {
              ...product,
              purchaseCount: newPurchaseCount
            })
          }
          // 장바구니가 화면이 아닌 경우, 장바구니 이동 팝업 표시
          if (router.currentRoute.path.indexOf('cart') < 0) {
            dispatch('modal/openModalGoToCart', null, { root: true })
          }
        })
      })
    })
  }
}

const increaseProductOfCart = ({ state, commit, dispatch }, product) => {
  const { productId, productStatus } = product
  if (productStatus === 2) {
    const cartItem = state.items.find(item => item.productId === productId)
    let newPurchaseCount
    if (cartItem) {
      newPurchaseCount = cartItem.purchaseCount + 1
      if (
        checkCountLimit(newPurchaseCount, product) === false ||
        newPurchaseCount > 10
      )
        return false
    }

    loginCheckWrap(() =>
      CartAPI.increaseProductOfCart(product, () => {
        dispatch('updateProductStatus', {
          ...product,
          purchaseCount: newPurchaseCount
        })
      })
    )
  }
}

const decreaseProductOfCart = ({ state, commit, dispatch }, product) => {
  const { productId, productStatus } = product
  if (productStatus === 2) {
    const cartItem = state.items.find(item => item.productId === productId)
    let newPurchaseCount
    if (cartItem) {
      newPurchaseCount = cartItem.purchaseCount - 1
      if (newPurchaseCount < 1) return false
    }

    loginCheckWrap(() =>
      CartAPI.decreaseProductOfCart(product, () => {
        dispatch('updateProductStatus', {
          ...product,
          purchaseCount: newPurchaseCount
        })
      })
    )
  }
}

/**
 * 상품을 장바구니에서 제거한다.
 * @param {*} param0
 * @param {string} productId - 상품 id
 */
const removeProductOfCart = ({ commit, getters, dispatch }, productId) => {
  let productIds = []

  if (typeof productId != 'undefined') {
    if (productId === null) {
      productIds = getters['checkedCartProducts'].map(el => el.productId)
    } else {
      productIds.push(productId)
    }
  }
  if (isLogin()) {
    if (getters['cartProducts'].length === productIds.length) {
      CartAPI.removeAllProductOfCart(() => {
        commit('REMOVE_PRODUCT_OF_CART', [])
        beforeSendLog('CheckDelete')
      })
    } else {
      CartAPI.removeProductOfCart(productIds, () => {
        commit('REMOVE_PRODUCT_OF_CART', productIds)
        beforeSendLog(`${productId ? '' : 'Check'}Delete`)
      })
    }
  } else {
    commit('REMOVE_PRODUCT_OF_CART', productIds)
  }
}
/**
 * 장바구니에 있는 상품의 상태 값을 갱신한다.
 * @param {*} param0
 * @param {Object} product - 상품 오브젝트
 */
const updateProductStatus = ({ commit, dispatch }, product) => {
  const { productStatus } = product
  if (productStatus === 2) {
    loginCheckWrap(() => {
      product.countLimit =
        checkCountLimit(product.purchaseCount, product, true) === false
      commit('UPDATE_PRODUCT_STATUS', product)
    })
  }
}
/**
 * 모든 상품의 check 상태를 갱신한다.
 * @param {*} param0
 * @param {Boolean} checked - 선택 값
 */
const updateAllProductCheckStatus = ({ commit, dispatch }, checked) => {
  loginCheckWrap(() => {
    commit('UPDATE_ALL_PRODUCT_CHECK_STATUS', checked)
  })
}

export default {
  getProductListOfCart,
  addProductOfCart,
  increaseProductOfCart,
  decreaseProductOfCart,
  removeProductOfCart,
  updateProductStatus,
  updateAllProductCheckStatus
}
